// extracted by mini-css-extract-plugin
module.exports = {"main":"SocialSVG_main__tu2LI","black":"SocialSVG_black__rbMqo","white":"SocialSVG_white__MTKrF","svg":"SocialSVG_svg__pCNcK"};